import { errorTostHandler } from "helper/ErrorTostHandler";
import {
  CHECK_USER_HAVING_SAME_SUBSCRIPTION,
  CLEAR_PRODUCT,
  CLEAR_SUBSCRIPTION_CONFIRMATION,
  REMOVE_CART,
  SET_AUTH_OPTION,
  SET_BILLING_ADDRESS,
  SET_BILLING_AMOUNT_DETAILS,
  SET_BILLING_AMOUNT_DETAILS_TEMP,
  SET_BILLING_COUPON_LIST,
  SET_CARD_DETAILS,
  SET_CART_DETAILS,
  SET_CHECKOUT_ERROR,
  SET_COMBO_DISCOUNT,
  SET_COUNTRIES,
  SET_COUNTRY_ID,
  SET_COUPON_CODE,
  SET_DISABLE_OTHER_STEP,
  SET_GUEST_USER,
  SET_GUEST_USER_EMAIL,
  SET_INTAKE_FORM,
  SET_LOADING,
  SET_LOADING_CART_DETAILS,
  SET_LOADING_COUNTRIES,
  SET_LOADING_COUPON,
  SET_LOADING_STATES,
  SET_LOADING_USER_PRODUCT_DETAILS,
  SET_PRODUCT,
  SET_PUBLIC_KEY,
  SET_RENEWAL_TOTAL,
  SET_SAVING_SUBSCRIPTION,
  SET_SHIPPING_ADDRESS,
  SET_SITE_PRODUCTS,
  SET_STATES,
  SET_UPGRADED_PRODUCT,
} from "./actionTypes";

import {
  CHECKOUT_USER_SUBSCRIPTION,
  CHECK_USER_HAVING_SAME_SUBSCRIPTION_URL,
  CUSTOM_CHECKOUT_USER_SUBSCRIPTION,
  DELETE_USER_CART,
  GET_CART_DETAILS,
  GET_CONFIRM_PRODUCT_DETAIL,
  GET_COUNTRIES,
  GET_STATES,
  SAVE_ADDRESS_DETAILS,
  SAVE_SUBSCRIPTION_DETAILS,
  UPDATE_USER_CART_USER_ID,
  VERIFY_COUPON,
  VERIFY_CUSTOM_CHECKOUT_PRODUCT,
} from "helper/url_helper";
import { toast } from "react-toastify";
import { axiosAccount } from "services/api";
import { fetchUserProfile } from "store/actions";

const getAddressDetails = value => ({
  user_address_id: value?.user_address_id || 0,
  first_name: value?.first_name || "",
  last_name: value?.last_name || "",
  phone_number: value?.phone_number || "",
  email_address: value?.email_address || "",
  address_line1: value?.address_line1 || "",
  address_line2: value?.address_line2 || "",
  city: value?.city || "",
  zipcode: value?.zipcode || "",
  state_id: value?.state_id || "",
  country_id: value?.country_id || "",
  is_shipping_same:
    value?.is_shipping_same !== undefined ? value.is_shipping_same : 0,
});

export const getSubscriptionDetails = data => async dispatch => {
  try {
    dispatch(setLoadingUserProductDetails(true));
    const res = await axiosAccount.post(GET_CONFIRM_PRODUCT_DETAIL, data);
    if (res.data?.data) {
      dispatch(setProduct(res.data.data.product));
      dispatch(setSiteProducts(res.data.data.site_product));

      // handle return url
      dispatch(setLoadingUserProductDetails(false));
    }
  } catch (err) {
    errorTostHandler(err);
    dispatch(setLoadingUserProductDetails(false));
  }
};

export const saveSubscriptionDetails = (data, cb) => async dispatch => {
  try {
    dispatch(setSavingSubscription(true));
    const res = await axiosAccount.post(SAVE_SUBSCRIPTION_DETAILS, data);
    if (res.data?.data) {
      dispatch(setSavingSubscription(false));
      cb();
    }
  } catch (err) {
    errorTostHandler(err);
    dispatch(setSavingSubscription(false));
  }
};

export const updatedUserCartUserId =
  ({ is_direct_link, is_guest }) =>
  async dispatch => {
    try {
      dispatch(setLoading(true));
      const res = await axiosAccount.post(UPDATE_USER_CART_USER_ID, {
        is_guest,
      });
      if (res.status) {
        dispatch(setLoading(false));
        dispatch(
          getCartDetails({
            site_id: 2,
            is_not_combo: is_direct_link,
          })
        );
      }
    } catch (err) {
      errorTostHandler(err);
      dispatch(setLoading(false));
    }
  };

export const deleteUserCart = (id, cb) => async dispatch => {
  try {
    dispatch(setLoading(true));
    const res = await axiosAccount.post(DELETE_USER_CART, {
      user_cart_id: id,
    });

    if (res.data?.data?.UserCartDetail) {
      const { UserCartDetail } = res.data.data;
      dispatch(setCartDetails(UserCartDetail.userCartDetailList));
      dispatch(setComboDiscount(UserCartDetail.combo_discount));
      dispatch(setRenewalTotal(UserCartDetail.renewalDetails));
      dispatch(setBillingAmount(UserCartDetail.billingAmount));
      dispatch(setCouponCode(""));
      cb();
    }
    if (res.status) {
      toast.success(res.data.message);
      dispatch(setLoading(false));
    }
  } catch (err) {
    errorTostHandler(err);
    dispatch(setLoading(false));
  }
};

export const getCartDetails = data => async dispatch => {
  try {
    dispatch(setLoadingCartDetails(true));
    const res = await axiosAccount.post(GET_CART_DETAILS, data);
    if (res.data?.data) {
      const {
        UserCartDetail,
        billingDetail,
        cardDetail,
        shippingDetail,
        paymentPublicKey,
      } = res.data.data;
      dispatch(setCartDetails(UserCartDetail.userCartDetailList));
      dispatch(setComboDiscount(UserCartDetail.combo_discount));
      dispatch(setRenewalTotal(UserCartDetail.renewalDetails));
      dispatch(setBillingAmount(UserCartDetail.billingAmount));
      dispatch(setBillingAmountTemp(UserCartDetail.billingAmount));
      dispatch(setShippingAddress({ ...getAddressDetails(shippingDetail) }));
      dispatch(setBillingAddress({ ...getAddressDetails(billingDetail) }));
      dispatch(setCardDetails(cardDetail));
      dispatch(setPublicKey(paymentPublicKey));
    }
    dispatch(setLoadingCartDetails(false));
  } catch (err) {
    errorTostHandler(err);
    dispatch(setLoadingCartDetails(false));
  }
};

export const getCountries = () => async dispatch => {
  try {
    dispatch(setLoadingCountries(true));
    const res = await axiosAccount.get(GET_COUNTRIES);

    if (res.data?.data?.countryList) {
      dispatch(setCountries(res.data.data.countryList));
    }
    if (res.status) dispatch(setLoadingCountries(false));
  } catch (err) {
    errorTostHandler(err);
    dispatch(setLoadingCountries(false));
  }
};

export const getStates = id => async dispatch => {
  try {
    dispatch(setLoadingStates(true));
    const res = await axiosAccount.get(`${GET_STATES}/${id}`);
    if (res.status) dispatch(setLoadingStates(false));
    if (res.data?.data?.stateList) {
      dispatch(setStates(res.data.data.stateList));
    }
  } catch (err) {
    errorTostHandler(err);
    dispatch(setLoadingStates(false));
  }
};

export const saveAddressDetails =
  (data, isBilling = false, cb) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const tempData =
        isBilling || !!data.is_shipping_same
          ? data
          : {
              ...getState().subscriptionConfirmation.billingDetails,
              user_address_id: data.user_address_id,
              address_type: 2,
            };
      const res = await axiosAccount.post(SAVE_ADDRESS_DETAILS, tempData);
      if (res.status) {
        if (+data.address_type === 1) dispatch(setBillingAddress(data));
        if (+data.address_type === 2) dispatch(setShippingAddress(data));

        dispatch(setLoading(false));
        if (!!cb && typeof cb === "function") cb();
      }
    } catch (err) {
      errorTostHandler(err);
      dispatch(setLoading(false));
    }
  };

export const applyCoupon =
  (data, cb = () => {}) =>
  async dispatch => {
    try {
      dispatch(setLoadingCoupon(true));
      const res = await axiosAccount.post(VERIFY_COUPON, data);
      if (res.data?.data?.couponDetails) {
        if (res.data.data.couponDetails.isVerified) {
          dispatch(setCouponCode(data.coupon_code));
          dispatch(setBillingAmount(res.data.data.couponDetails.billingAmount));
          dispatch(
            setBillingCouponList(res.data.data.couponDetails.coupons_data)
          );
          // toast.success(res.data.message);
        } else {
          toast.error("Invalid coupon code");
        }
        cb({
          success: res.data?.data,
          error: null,
        });
      }
      dispatch(setLoadingCoupon(false));
    } catch (err) {
      // toast.error(err.response?.data?.message || err.message);
      cb({
        success: null,
        error: err.response?.data?.message || err.message,
      });
      dispatch(setLoadingCoupon(false));
    }
  };

export const verifyCustomCheckOutProduct = data => async dispatch => {
  try {
    dispatch(setLoadingCoupon(true));
    const res = await axiosAccount.post(VERIFY_CUSTOM_CHECKOUT_PRODUCT, data);
    if (res.data?.data) {
      dispatch(setUpgradedProduct(res.data.data.basic_product_id));
    }
    dispatch(setLoadingCoupon(false));
  } catch (err) {
    dispatch(setLoadingCoupon(false));
  }
};

export const checkoutSubmit = (data, cb) => async dispatch => {
  try {
    dispatch(setLoading(true));
    const res = await axiosAccount.post(CHECKOUT_USER_SUBSCRIPTION, data);
    if (res.status) {
      // toast.success(res.data.message);
      // dispatch(fetchVolumesMemberships());
      dispatch(fetchUserProfile());
      dispatch(setLoading(false));
      if (!!cb && typeof cb === "function") cb(res);
    }
  } catch (err) {
    errorTostHandler(err);
    dispatch(setLoading(false));
  }
};

export const customCheckOutUserSubscription = (data, cb) => async dispatch => {
  try {
    dispatch(setLoading(true));
    const res = await axiosAccount.post(
      CUSTOM_CHECKOUT_USER_SUBSCRIPTION,
      data
    );
    if (res.status) {
      toast.success(res.data.message);
      // dispatch(fetchVolumesMemberships());
      dispatch(fetchUserProfile());
      dispatch(setLoading(false));
      if (!!cb && typeof cb === "function") cb(res);
    }
  } catch (err) {
    errorTostHandler(err);
    dispatch(setLoading(false));
  }
};

export const setLoading = data => ({
  type: SET_LOADING,
  payload: data,
});

export const setProduct = data => ({
  type: SET_PRODUCT,
  payload: data,
});
export const setSiteProducts = data => ({
  type: SET_SITE_PRODUCTS,
  payload: data,
});
export const setCartDetails = data => ({
  type: SET_CART_DETAILS,
  payload: data,
});
export const removeCart = data => ({
  type: REMOVE_CART,
  payload: data,
});
export const setCountries = data => ({
  type: SET_COUNTRIES,
  payload: data,
});
export const setStates = data => ({
  type: SET_STATES,
  payload: data,
});
export const setCouponCode = data => ({
  type: SET_COUPON_CODE,
  payload: data,
});
export const setShippingAddress = data => ({
  type: SET_SHIPPING_ADDRESS,
  payload: data,
});
export const setBillingAddress = data => ({
  type: SET_BILLING_ADDRESS,
  payload: data,
});
export const setCardDetails = data => ({
  type: SET_CARD_DETAILS,
  payload: data,
});
export const setCountryId = data => ({
  type: SET_COUNTRY_ID,
  payload: data,
});
export const setBillingAmount = data => ({
  type: SET_BILLING_AMOUNT_DETAILS,
  payload: data,
});
export const setBillingAmountTemp = data => ({
  type: SET_BILLING_AMOUNT_DETAILS_TEMP,
  payload: data,
});
export const setBillingCouponList = data => ({
  type: SET_BILLING_COUPON_LIST,
  payload: data,
});

export const setComboDiscount = data => ({
  type: SET_COMBO_DISCOUNT,
  payload: data,
});
export const setRenewalTotal = data => ({
  type: SET_RENEWAL_TOTAL,
  payload: data,
});
export const setLoadingCartDetails = data => ({
  type: SET_LOADING_CART_DETAILS,
  payload: data,
});
export const setSavingSubscription = data => ({
  type: SET_SAVING_SUBSCRIPTION,
  payload: data,
});
export const setLoadingCoupon = data => ({
  type: SET_LOADING_COUPON,
  payload: data,
});

export const setLoadingUserProductDetails = data => ({
  type: SET_LOADING_USER_PRODUCT_DETAILS,
  payload: data,
});
export const clearProduct = () => ({
  type: CLEAR_PRODUCT,
});
export const setLoadingCountries = data => ({
  type: SET_LOADING_COUNTRIES,
  payload: data,
});
export const setLoadingStates = data => ({
  type: SET_LOADING_STATES,
  payload: data,
});
export const setPublicKey = data => ({
  type: SET_PUBLIC_KEY,
  payload: data,
});
export const clearSubscriptionConfirmation = () => ({
  type: CLEAR_SUBSCRIPTION_CONFIRMATION,
});

export const checkUserHavingSameSubscription =
  (data, callBack) => async dispatch => {
    try {
      dispatch(setLoading(true));
      const res = await axiosAccount.post(
        CHECK_USER_HAVING_SAME_SUBSCRIPTION_URL,
        data
      );
      if (res.data?.data) {
        dispatch(
          setUserHavingSameSubscription(res.data.data.user_having_subscription)
        );
        callBack(res.data.data.user_having_subscription);
      }
      if (res.status) dispatch(setLoading(false));
    } catch (err) {
      errorTostHandler(err);
      dispatch(setLoading(false));
    }
  };
export const setUserHavingSameSubscription = data => ({
  type: CHECK_USER_HAVING_SAME_SUBSCRIPTION,
  payload: data,
});

export const setInTakeFromData = data => ({
  type: SET_INTAKE_FORM,
  payload: data,
});

export const setCheckoutError = data => ({
  type: SET_CHECKOUT_ERROR,
  payload: data,
});

export const setUpgradedProduct = data => ({
  type: SET_UPGRADED_PRODUCT,
  payload: data,
});

export const setGuestUser = data => ({
  type: SET_GUEST_USER,
  payload: data,
});

export const setAuthOption = data => ({
  type: SET_AUTH_OPTION,
  payload: data,
});

export const setGuestUerEmail = data => ({
  type: SET_GUEST_USER_EMAIL,
  payload: data,
});

export const setDisableOtherStep = data => ({
  type: SET_DISABLE_OTHER_STEP,
  payload: data,
});
